// extracted by mini-css-extract-plugin
export var container = "ProudOfSection-module--container--3V8Zw";
export var linkContainer = "ProudOfSection-module--linkContainer--BMDd4";